module.exports = __webpack_public_path__ + "static/img/3.52f8ca8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/clientes/3.png
// module id = ojqS
// module chunks = 0